import { CSSProperties, ReactNode } from 'react';

import { Text as TextComponent, TextProps as TextComponentProps } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { useThemedValue } from '@sternum/web/hooks/useThemedValue';

export interface TextProps extends Omit<TextComponentProps, 'color'> {
  color?: Color;
  style?: CSSProperties;
  children?: ReactNode;
}

type ColorKey = keyof typeof Colors;
interface Color {
  Dark: ColorKey;
  Light: ColorKey;
}

const defaultColors = { Dark: Colors.White, Light: Colors.DarkerText };

export function Text(props: TextProps) {
  const themedColor = props.color
    ? { Dark: Colors[props.color.Dark], Light: Colors[props.color.Light] }
    : defaultColors;

  const themedColorValue = useThemedValue(themedColor) as ColorKey;

  return <TextComponent {...props} color={themedColorValue} />;
}
